import { monthEndAlertConstants } from '../../actions/constant';

const { SUCCESS_GET_STATUS_CERTIFY, FAILURE_GET_STATUS_CERTIFY, LOADING_GET_STATUS_CERTIFY } =
  monthEndAlertConstants;

const intitialstate: object = {
  response: null,
  getStatus: false,
  loading: false,
};

export const getCertificationStatusReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_STATUS_CERTIFY: {
      return {
        ...state,
        getStatus: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_GET_STATUS_CERTIFY:
      return {
        ...state,
        getStatus: false,
        response: action.payload,
        loading: false,
      };

    case LOADING_GET_STATUS_CERTIFY:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
